var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-list", class: _vm.containerClasses },
    [
      _vm.summary
        ? [
            _c("ul", { staticClass: "c-list__list" }, [
              _c("li", { staticClass: "c-list__item c-list__inline" }, [
                _c(
                  "div",
                  { staticClass: "c-list-container--small" },
                  [
                    _vm.summaryIcon
                      ? [
                          _c("v-icon", {
                            attrs: {
                              name: "icon-" + _vm.summaryIcon,
                              cssModifiers:
                                _vm.summaryIconColor +
                                " c-list__icon c-icon--xs"
                            }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "c-list__title" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.summaryItem) +
                          " och " +
                          _vm._s(_vm.advantages) +
                          " andra\n\t\t\t\t\t\tfördelar\n\t\t\t\t\t"
                      )
                    ])
                  ],
                  2
                )
              ])
            ])
          ]
        : [
            _vm.heading
              ? [
                  _c("h2", { staticClass: "c-footer__contact-heading" }, [
                    _vm._v(_vm._s(_vm.heading))
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "c-list__list" },
              _vm._l(_vm.listItems, function(item, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "c-list__item" },
                  [
                    item.href
                      ? [
                          item.icon
                            ? _c(
                                "div",
                                {
                                  staticClass: "c-contact",
                                  staticStyle: { "margin-bottom": "16px" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-contact__icon" },
                                    [
                                      _c("v-icon", {
                                        attrs: { name: item.icon, size: "s" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "c-contact__heading-and-text"
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "c-contact__heading" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(item.name) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "c-contact__link" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "c-contact--action",
                                              attrs: { href: item.href }
                                            },
                                            [_vm._v(_vm._s(item.linkText))]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  style: _vm.isFooter
                                    ? "margin-left: 32px"
                                    : "margin-left: -8px"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "c-list__link no-style",
                                      class: {
                                        "c-list__link--active": _vm.active
                                      },
                                      attrs: {
                                        href: item.href,
                                        target: item.target
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(item.name) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]
                              )
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "c-list-container--small" },
                            [
                              item.icon
                                ? [
                                    _c("v-icon", {
                                      attrs: {
                                        name: "icon-" + item.icon,
                                        cssModifiers:
                                          item.iconColor +
                                          " c-list__icon c-icon--" +
                                          _vm.iconSize
                                      }
                                    })
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "c-list__title" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(item.name) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ])
                            ],
                            2
                          )
                        ],
                    _vm._v(" "),
                    item.description
                      ? _c("span", { staticClass: "c-list-title__undertext" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      : _vm._e()
                  ],
                  2
                )
              }),
              0
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }